<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-space-x-4">
        <div class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3">
          <div class="ts-flex ts-justify-between ts-space-x-3">
            <a-select 
              v-model="modelFilter.category_id"
              class="ts-w-full"
              mode="multiple"
              :options="categories"
              :maxTagCount="2"
              placeholder="Category"
              @change="fetchResource()"
            ></a-select>
            <SearchBox v-model="modelFilter.product_id" />
          </div>
          <ts-checkbox
            v-model.number="modelFilter.is_printed"
            @change="fetchResource()"
          >{{ $t('productLabel.printed') }}</ts-checkbox>
          <p class="ts-font-semibold ts-mt-3" >{{ $t('productLabel.selected') + ': ' + leftSelected.length + '/' + (totalRecord - productRightList.length)  }}</p>
          <div class="ts-flex-none max-height min-height ts-mt-3">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                  >
                    <input
                      type="checkbox"
                      class="ts-mt-1"
                      v-model="leftListIsAllCheck"
                      @change="onLeftListAllCheckChange"
                    />
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.barcode') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.productGroup') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.nameEn') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pro, index) in productList" :key="index">
                  <td class="ts-py-1 ts-px-3 ts-w-3">
                    <input
                      type="checkbox"
                      v-model="leftSelected"
                      :value="pro"
                      @change="onLeftItemChange"
                    />
                  </td>
                  <td class="ts-py-1 ts-px-3">{{ pro.barcode }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.pro_group_name_en }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.product_name_en }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <a-pagination 
            v-if="totalRecord > 0"
            size="small" 
            :pageSize="perPage" 
            :total="totalRecord"
            :showSizeChanger="true"
            :pageSizeOptions="['300', '500', '1000']"
            @showSizeChange="onPerPageChange"
            @change="onPaginChange"
            class="ts-float-right" 
          />
        </div>
        <!-- move left right button -->
        <div class="ts-flex ts-items-center">
          <div class="ts-h-24 ts-space-y-3 ts-flex-none">
            <button
              @click.prevent="moveToRight"
              class="
                ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded
                focus:ts-outline-none
              "
            >
              <i class="fas fa-chevron-right"></i>
            </button>
            <br />
            <button
              @click.prevent="moveLeft"
              class="
                ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded
                focus:ts-outline-none
              "
            >
              <i class="fas fa-chevron-left"></i>
            </button>
          </div>
        </div>
        <div class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3">
          <div class="ts-flex-none max-height min-height">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                  >
                    <input
                      type="checkbox"
                      class="ts-mt-1"
                      v-model="rightListIsAllCheck"
                      @change="onRightListAllCheckChange"
                    />
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.barcode') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.productGroup') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.nameEn') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.qty') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pro, index) in productRightList" :key="index">
                  <td valign="middle" class="ts-py-1 ts-px-3 ts-w-3">
                    <input
                      type="checkbox"
                      v-model="righSelected"
                      :value="pro"
                      @change="onRightItemChange"
                    />
                  </td>
                  <td valign="middle" class="ts-py-1 ts-px-3">{{ pro.barcode }}</td>
                  <td valign="middle" class="ts-py-1 ts-px-3">{{ pro.pro_group_name_en }}</td>
                  <td valign="middle" class="ts-py-1 ts-px-3">{{ pro.product_name_en }}</td>
                  <td valign="middle" class="ts-py-1 ts-px-3 ts-w-20">
										<input 
											type="number" 
											v-model.number="pro.qty"
											min="1" 
											class="ts-w-full ts-border ts-border-gray-200 ts-rounded ts-px-2 ts-py-1"
										>
										<div class="validate ts-whitespace-no-wrap" v-if="errors.has('product_barcode_list.'+ index + '.qty' )">
											{{ errors.first('product_barcode_list.'+ index + '.qty' ) }}
										</div>
									</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
			      <div class="ts-flex ts-justify-end ts-mt-3 ts-space-x-3 ts-w-full">
        <ts-button
          :waiting="waiting"
          @click.prevent="onPreview"
          color="primary"
          >{{ $t('preview') }}</ts-button
        >
      </div>
			  <a-modal :title="$t('pdf')" width="700px" v-model="show_pdf" :footer="null">
					<ts-preview-pdf v-model="waiting" :src="src" />
				</a-modal>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import SearchBox from './search-box.vue'

export default {
  name: 'printBarcode',
  components: {
    SearchBox,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_pdf: false,
      show_stock_in_modal: false,
      waiting: false,
      src: '',
      purchaseInvoice: {},
      productSearch: {
        text: '',
      },
      leftListIsAllCheck: false,
      rightListIsAllCheck: false,
      leftSelected: [],
      righSelected: [],
      productResources: [],
      categories: [],
      totalRecord: 0,
      page: 1,
      perPage: 30,
      model: {
        product_barcode_list: [],
      },
      modelFilter:{
        is_printed: false,
        product_id: [],
        category_id: []
      }
    }
  },
  computed: {
    productList() {
      return this.productResources.filter(
        (p) => !_.includes(this.model.product_barcode_list.map(el => el.barcode), p.barcode) && p.is_printed == this.modelFilter.is_printed
      )
    },
    productRightList() {
      return this.productResources.filter((p) =>
        _.includes(this.model.product_barcode_list.map(el => el.barcode), p.barcode)
      )
    },
  },
  created() {
    this.fetchCategory()
  },
  methods: {
    ...mapActions('product/label', ['getProductBarcode', 'printBarcode', 'getCategory']),
		onPreview() {
      this.src = ''
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.printBarcode(this.model)
        .then((response) => {
          this.src = response.url
          this.updateStatus()
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchCategory(){
      this.loading = true
      this.getCategory()
        .then(response => {
          this.categories = response.data.map(el => ({
            value: el.category_id,
            label: el.category_name_en
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchResource() {
      this.loading = true
      this.leftSelected = []
      this.getProductBarcode({
        params: {
          filter: {
            product_id: _.join(this.modelFilter.product_id, ','),
            category_id: _.join(this.modelFilter.category_id, ','),
            is_printed: this.is_printed,
          },
          page: this.page,
          per_page: this.perPage
        },
      })
        .then((response) => {
          this.productResources = response.data
          this.totalRecord = response.meta.total
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // check all item in the left panel
    onLeftListAllCheckChange(e) {
      if (e.target.checked) {
        this.leftSelected = this.productList.map((el) => el)
      } else {
        this.leftSelected = []
      }
    },
    // check all item in the right panel
    onRightListAllCheckChange(e) {
      if (e.target.checked) {
        this.righSelected = this.productRightList.map((el) => el)
      } else {
        this.righSelected = []
      }
    },
    // check weather all lett item is check or not
    onLeftItemChange() {
      this.leftListIsAllCheck =
        this.leftSelected.length == this.productList.length
    },
    // check weather all right item is check or not
    onRightItemChange() {
      this.leftListIsAllCheck =
        this.leftSelected.length == this.productRightList.length
    },
    // action move item to the right panel
    moveToRight() {
      this.model.product_barcode_list.push(...this.leftSelected.map(el => Object.assign(el, { qty: 1 })))
      this.leftSelected = []
      this.leftListIsAllCheck = false
    },
    // action move item to the left back panel
    moveLeft() {
      this.model.product_barcode_list = this.model.product_barcode_list.filter(
        (p) => !_.includes(this.righSelected.map(el => el.barcode), p.barcode)
      )
      this.righSelected = []
      this.rightListIsAllCheck = false
    },
    clearInput() {
      this.model.product_barcode_list = []
    },
    updateStatus(){
      this.model.product_barcode_list.forEach(product => {
          this.productResources[this.productResources.findIndex(s => s.product_id == product.product_id)].is_printed = true
      });
    },
    onPerPageChange(current, size){
      this.perPage = size
      this.fetchResource()
    },
    onPaginChange(page, pageSize){
      this.page = page
      this.fetchResource()
    }
  },
	watch: {
    'modelFilter.product_id': debounce(function (search) {
      this.fetchResource()
    }, 500),
  },
}
</script>

<style scoped lang="css">
.max-height {
  max-height: 500px;
  overflow-y: scroll;
}
.min-height {
  min-height: 400px;
}
</style>